import { SxProps, Theme } from "@mui/material";

export const additionalInformationFareharborStyles = {
    fieldContainer: {
        mb: 0.4,
    },
    nonOptionHeader: (): SxProps<Theme> => ({
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
    }),
    fieldTitle: (theme: Theme): SxProps<Theme> => ({
        fontSize: 17,
        fontWeight: 600,
        fontFamily: theme.typography.fontFamily,
        marginBottom: 0,
        lineHeight: "25px",
    }),
    fieldTitleFH: (theme: Theme): SxProps<Theme> => ({
        fontSize: 15,
        fontWeight: 400,
        fontFamily: theme.typography.fontFamily,
        marginBottom: 0.5,
        marginTop: 1,
        lineHeight: "22.5px",
        letterSpacing: "0.27px"
    }),

    requiredAsterisk: {
        color: "#000",
        fontWeight: "bold",
    },
    extendedOptionHeader: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
        marginBottom: "3px",
    },
    extendedOptionTitle: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 400,
        fontSize: 15,
        fontFamily: theme.typography.fontFamily,
        mt: 2,
        mb: 0.5,
    }),
    extendedOptionSelect: {
        borderRadius: "8px",
        "& .MuiMenuItem-root": {
            whiteSpace: "normal",
            wordBreak: "break-word",
        },
        "& .MuiSelect-select": {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "13px 15px !important",
        },
    },
    menuItem: {
        whiteSpace: "normal",
        wordBreak: "break-word",
    },
    optionContainer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    optionPriceText: {
        fontSize: 15,
        fontWeight: 700,
    },
    optionDescription: {
        fontStyle: "italic",
        fontSize: "13px",
        lineHeight: "20px",
        color: "#2e2e2e",
    },

    optionDescriptionFH: {
        fontStyle: "italic",
        fontSize: "13px",
        lineHeight: "20px",
        color: "#2e2e2e",
    },
    textFieldStyle: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
        },
    },
    textFieldStyleFH: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
        },
        "& .MuiOutlinedInput-input": {
            paddingY: "13px",
        },
    },
    countContainer: {
        display: "flex",
        alignItems: "center",
        gap: 2,
    },
    countSelect: {
        borderRadius: "8px",
        border: "1px solid #8D8D8D",
        width: "100px",
    },
    yesNoHeader: {
        mb: 2,
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: 1,
    },
    yesNoHeaderText: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 600,
        fontSize: 17,
        fontFamily: theme.typography.fontFamily,
    }),
    yesNoContainer: {
        display: "flex",
        alignItems: "flex-start",
        border: "1px solid #595959",
        borderRadius: "8px",
        padding: "8px",
        marginBottom: "24px",
        "&:last-child": { marginBottom: 0 },
    },
    checkboxStyle: {
        mt: 1,
        "& .MuiCheckbox-root": {
            borderRadius: "4px",
            width: "25px",
            height: "25px",
        },
        "& .Mui-checked": {
            color: "#328734",
        },
    },
    checkboxTextContainer: {
        ml: 1,
        flex: 1,
    },
    checkboxHeaderContainer: {
        marginBottom: "3px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    checkboxTitle: (theme: Theme): SxProps<Theme> => ({
        fontWeight: 700,
        fontSize: 17,
        fontFamily: theme.typography.fontFamily,
    }),
    checkBoxPrice: {
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: "18.5px",
        letterSpacing: "0.203px"
    },
    checkboxDescription: {
        fontSize: 13,
        fontWeight: 400,
        lineHeight: "18.5px",
        letterSpacing: "0.203px",
    },
    customDropDownIconStyle: {
        width: "16px",
        height: "16px",
        marginRight: "12px",
    },
};
